import { render, staticRenderFns } from "./notice-edit.vue?vue&type=template&id=1c640562&scoped=true&"
import script from "./notice-edit.vue?vue&type=script&lang=ts&"
export * from "./notice-edit.vue?vue&type=script&lang=ts&"
import style0 from "./notice-edit.vue?vue&type=style&index=0&id=1c640562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c640562",
  null
  
)

export default component.exports